import ScheduleIcon from "@mui/icons-material/Schedule";
import { Box, Dialog, IconButton, Tooltip } from "@mui/material";
import { useDialog } from "common";
import I18n from "i18n";
import { useEventEditorContext } from "./EventEditorContext";
import ShiftGroupForm from "./ShiftGroupForm";

export default function ShiftGroupsButton() {
  const { cal, groupActionsEnabled } = useEventEditorContext();
  const [isOpen, setIsOpen, dialogProps] = useDialog();

  return (
    <>
      <Tooltip title={I18n.t("EventEditor.groupEdit.shift")}>
        <Box>
          <IconButton
            color="info"
            onClick={() => setIsOpen(true)}
            disabled={!groupActionsEnabled}
          >
            <ScheduleIcon />
          </IconButton>
        </Box>
      </Tooltip>
      <Dialog {...dialogProps} maxWidth="sm" fullWidth>
        <ShiftGroupForm
          onClose={dialogProps.onClose}
          afterSave={() => {
            cal?.current?.refresh();
            dialogProps.onClose && dialogProps.onClose({}, "backdropClick");
          }}
        />
      </Dialog>
    </>
  );
}
